import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchLookAndFeel as thunkLookAndFeel } from '_config/store/app/app.thunk';
import { createAccountGs1Thunk, enrollmentStepGs1Thunk } from 'partner/Gs1/gs1.thunk';
import { signUp } from '_config/store/account/account.thunk';
import { setEnrollmentStepGs1 } from 'partner/Gs1/store/enrollmentStepGs1.slice';
import lookAndFeel from '../utilities/lookAndFeel';

const useOnBoarding = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();

  const {
    error: lookAndFeelError,
    isLoading: lookAndFeelIsLoading
  } = useSelector((s) => s.app.lookAndFeel);
  
  const {
    data: account,
    error: accountError,
    isLoading: accountIsLoading
  } = useSelector((s) => s?.partner?.gs1?.createAccount);

  const fetchLookAndFeel = (params, force = false) => {
    if (lookAndFeel === null || force) {
      thunkLookAndFeel(params);
    }
  };

  const logoutAuth0 = (partner) => logout({
    logoutParams: 
      { returnTo: `${window.location.origin}/partner/${partner}/login` } 
  });

  const resetEnrollmentStep = () => dispatch(setEnrollmentStepGs1());

  const sendCompanyData = (_id, data, extra = {}) => dispatch(enrollmentStepGs1Thunk(_id, {
    c: [{ data, step: 1 }]
  }, extra));

  const sendSalesChannels = (_id, data, extras = {}) => 
    dispatch(enrollmentStepGs1Thunk(_id, {
      c: [{ data, step: 2 }]
    }, extras));

  const sendSignUp = (data, extras = {}) => dispatch(signUp({
    fork: "gs1",
    ...data
  }, extras));

  const sendUserData = (_id, data, extras = {}) => dispatch(enrollmentStepGs1Thunk(_id, {
    c: [{ data, step: 0 }]
  
  }, extras));

  const createAccountGs1 = (params) => dispatch(createAccountGs1Thunk(params));

  return {
    account,
    accountError,
    accountIsLoading,
    createAccountGs1,
    logoutAuth0,
    lookAndFeel,
    lookAndFeelError,
    lookAndFeelIsLoading,
    fetchLookAndFeel,
    resetEnrollmentStep,
    sendCompanyData,
    sendUserData,
    sendSalesChannels,
    sendSignUp
  };
};

export default useOnBoarding;
